export const languages = [
  { code: 'en', name: 'English' },
  { code: 'ru', name: 'Русский' },
  { code: 'es', name: 'Español' },
  { code: 'fr', name: 'Français' },
  { code: 'de', name: 'Deutsch' },
  { code: 'it', name: 'Italiano' },
  { code: 'pt', name: 'Português' },
  { code: 'zh', name: '中文' },
  { code: 'ja', name: '日本語' },
  { code: 'ko', name: '한국어' },
  { code: 'ar', name: 'العربية' },
  { code: 'tr', name: 'Türkçe' }
];

export const translations = {
  en: {
    about: "About",
    title: "Boobs Works — 3D Bust Generator",
    intro: "Boobs Works is a free, browser-based parametric 3D bust generator for artists, sculptors, and 3D printing enthusiasts. Adjust anatomy with real-time controls and export production-ready meshes in STL or OBJ format — no software installation required.",
    featuresTitle: "Features",
    features: [
      "10 parametric controls: volume, sag, nipple geometry, areola size, skin tone, roughness, subsurface scattering, and vein detail",
      "Real-time WebGL rendering with custom GLSL skin shaders",
      "Export to STL (for 3D printing) or OBJ (for use in Blender, ZBrush, Maya, etc.)",
      "Built-in presets: Petite, Natural, Full, Athletic, Dark",
      "Random generator for quick inspiration and reference poses"
    ],
    useCasesTitle: "Use Cases",
    useCasesText: "Designed for character artists, figure sculptors, game developers, and 3D printing hobbyists who need accurate anatomical reference or printable meshes. The generator is useful for life drawing reference, base mesh creation, prosthetics design, and artistic exploration.",
    howItWorksTitle: "How It Works",
    howItWorksText: "All geometry is computed procedurally in the browser using Three.js. No assets are downloaded — the mesh is generated on-the-fly from mathematical surface functions. Skin rendering uses a physically-based material with subsurface scattering to simulate realistic tissue depth and translucency. Exported files are clean, manifold meshes ready for slicing or sculpting.",
    back: "← Open Generator",
    generator: "Generator"
  },
  ru: {
    about: "О проекте",
    title: "Boobs Works — 3D Генератор Бюста",
    intro: "Boobs Works — это бесплатный браузерный параметрический 3D-генератор бюстов для художников, скульпторов и энтузиастов 3D-печати. Настраивайте анатомию с помощью элементов управления в реальном времени и экспортируйте готовые к производству сетки в формате STL или OBJ — установка программного обеспечения не требуется.",
    featuresTitle: "Особенности",
    features: [
      "10 параметрических элементов управления: объем, обвисание, геометрия сосков, размер ареолы, тон кожи, шероховатость, подповерхностное рассеивание и детализация вен",
      "Рендеринг WebGL в реальном времени с пользовательскими шейдерами кожи GLSL",
      "Экспорт в STL (для 3D-печати) или OBJ (для использования в Blender, ZBrush, Maya и т.д.)",
      "Встроенные пресеты: Миниатюрный, Естественный, Полный, Спортивный, Темный",
      "Случайный генератор для быстрого вдохновения и референсных поз"
    ],
    useCasesTitle: "Сценарии использования",
    useCasesText: "Разработан для художников по персонажам, скульпторов фигур, разработчиков игр и любителей 3D-печати, которым нужны точные анатомические референсы или сетки для печати. Генератор полезен для референсов при рисовании с натуры, создания базовых сеток, дизайна протезов и художественных исследований.",
    howItWorksTitle: "Как это работает",
    howItWorksText: "Вся геометрия вычисляется процедурно в браузере с использованием Three.js. Никакие ресурсы не скачиваются — сетка генерируется на лету из математических функций поверхностей. Рендеринг кожи использует физически корректный материал с подповерхностным рассеиванием для имитации реалистичной глубины и полупрозрачности тканей. Экспортируемые файлы представляют собой чистые многообразные сетки, готовые к нарезке или скульптингу.",
    back: "← Открыть генератор",
    generator: "Генератор"
  },
  es: {
    about: "Acerca de",
    title: "Boobs Works — Generador de Busto 3D",
    intro: "Boobs Works es un generador de busto 3D paramétrico gratuito basado en navegador para artistas, escultores y entusiastas de la impresión 3D. Ajuste la anatomía con controles en tiempo real y exporte mallas listas para producción en formato STL u OBJ, sin necesidad de instalar software.",
    featuresTitle: "Características",
    features: [
      "10 controles paramétricos: volumen, flacidez, geometría del pezón, tamaño de la areola, tono de piel, rugosidad, dispersión subsuperficial y detalle de las venas",
      "Renderizado WebGL en tiempo real con sombreadores de piel GLSL personalizados",
      "Exportación a STL (para impresión 3D) u OBJ (para uso en Blender, ZBrush, Maya, etc.)",
      "Ajustes preestablecidos incorporados: Pequeña, Natural, Llena, Atlética, Oscura",
      "Generador aleatorio para inspiración rápida y poses de referencia"
    ],
    useCasesTitle: "Casos de Uso",
    useCasesText: "Diseñado para artistas de personajes, escultores de figuras, desarrolladores de juegos y aficionados a la impresión 3D que necesitan referencias anatómicas precisas o mallas imprimibles. El generador es útil para referencias de dibujo al natural, creación de mallas base, diseño de prótesis y exploración artística.",
    howItWorksTitle: "Cómo Funciona",
    howItWorksText: "Toda la geometría se calcula por procedimientos en el navegador utilizando Three.js. No se descargan activos: la malla se genera sobre la marcha a partir de funciones de superficie matemáticas. El renderizado de la piel utiliza un material basado en la física con dispersión subsuperficial para simular una profundidad y translucidez del tejido realistas. Los archivos exportados son mallas limpias y múltiples listas para cortar o esculpir.",
    back: "← Abrir Generador",
    generator: "Generador"
  },
  fr: {
    about: "À propos",
    title: "Boobs Works — Générateur de Buste 3D",
    intro: "Boobs Works est un générateur de buste 3D paramétrique gratuit basé sur un navigateur pour les artistes, les sculpteurs et les passionnés d'impression 3D. Ajustez l'anatomie avec des contrôles en temps réel et exportez des maillages prêts pour la production au format STL ou OBJ — aucune installation de logiciel requise.",
    featuresTitle: "Caractéristiques",
    features: [
      "10 contrôles paramétriques : volume, affaissement, géométrie du mamelon, taille de l'aréole, teint, rugosité, diffusion sous-surfacique et détails des veines",
      "Rendu WebGL en temps réel avec shaders de peau GLSL personnalisés",
      "Exportation vers STL (pour impression 3D) ou OBJ (pour utilisation dans Blender, ZBrush, Maya, etc.)",
      "Préréglages intégrés : Petite, Naturel, Plein, Athlétique, Foncé",
      "Générateur aléatoire pour une inspiration rapide et des poses de référence"
    ],
    useCasesTitle: "Cas d'utilisation",
    useCasesText: "Conçu pour les artistes de personnages, les sculpteurs de figures, les développeurs de jeux et les amateurs d'impression 3D qui ont besoin de références anatomiques précises ou de maillages imprimables. Le générateur est utile pour les références de dessin d'après nature, la création de maillages de base, la conception de prothèses et l'exploration artistique.",
    howItWorksTitle: "Comment ça marche",
    howItWorksText: "Toute la géométrie est calculée de manière procédurale dans le navigateur à l'aide de Three.js. Aucun actif n'est téléchargé — le maillage est généré à la volée à partir de fonctions de surface mathématiques. Le rendu de la peau utilise un matériau basé sur la physique avec diffusion sous-surfacique pour simuler une profondeur et une translucidité réalistes des tissus. Les fichiers exportés sont des maillages propres et multiples prêts à être découpés ou sculptés.",
    back: "← Ouvrir le Générateur",
    generator: "Générateur"
  },
  de: {
    about: "Über",
    title: "Boobs Works — 3D-Büsten-Generator",
    intro: "Boobs Works ist ein kostenloser, browserbasierter parametrischer 3D-Büsten-Generator für Künstler, Bildhauer und 3D-Druck-Enthusiasten. Passen Sie die Anatomie mit Echtzeit-Steuerungen an und exportieren Sie produktionsreife Netze im STL- oder OBJ-Format – keine Softwareinstallation erforderlich.",
    featuresTitle: "Eigenschaften",
    features: [
      "10 parametrische Steuerungen: Volumen, Durchhängen, Brustwarzengeometrie, Vorhofgröße, Hautton, Rauheit, Subsurface Scattering und Venendetails",
      "Echtzeit-WebGL-Rendering mit benutzerdefinierten GLSL-Haut-Shadern",
      "Export als STL (für 3D-Druck) oder OBJ (zur Verwendung in Blender, ZBrush, Maya usw.)",
      "Integrierte Voreinstellungen: Zierlich, Natürlich, Voll, Athletisch, Dunkel",
      "Zufallsgenerator für schnelle Inspiration und Referenzposen"
    ],
    useCasesTitle: "Anwendungsfälle",
    useCasesText: "Entwickelt für Charakterkünstler, Figuren-Bildhauer, Spieleentwickler und 3D-Druck-Bastler, die genaue anatomische Referenzen oder druckbare Netze benötigen. Der Generator ist nützlich für Aktzeichenreferenzen, die Erstellung von Basisnetzen, Prothesendesign und künstlerische Erkundungen.",
    howItWorksTitle: "Wie es funktioniert",
    howItWorksText: "Die gesamte Geometrie wird prozedural im Browser mit Three.js berechnet. Es werden keine Assets heruntergeladen – das Netz wird on-the-fly aus mathematischen Oberflächenfunktionen generiert. Das Haut-Rendering verwendet ein physikalisch basiertes Material mit Subsurface Scattering, um realistische Gewebetiefe und Transluzenz zu simulieren. Die exportierten Dateien sind saubere, mannigfaltige Netze, die zum Slicen oder Sculpting bereit sind.",
    back: "← Generator öffnen",
    generator: "Generator"
  },
  it: {
    about: "Informazioni",
    title: "Boobs Works — Generatore di Busto 3D",
    intro: "Boobs Works è un generatore di busto 3D parametrico gratuito basato su browser per artisti, scultori e appassionati di stampa 3D. Regola l'anatomia con controlli in tempo reale ed esporta mesh pronte per la produzione in formato STL o OBJ: nessuna installazione di software richiesta.",
    featuresTitle: "Caratteristiche",
    features: [
      "10 controlli parametrici: volume, cedimento, geometria del capezzolo, dimensione dell'areola, tono della pelle, rugosità, scattering sub-superficiale e dettaglio delle vene",
      "Rendering WebGL in tempo reale con shader per pelle GLSL personalizzati",
      "Esporta in STL (per la stampa 3D) o OBJ (per l'uso in Blender, ZBrush, Maya, ecc.)",
      "Preimpostazioni integrate: Minuta, Naturale, Piena, Atletica, Scura",
      "Generatore casuale per un'ispirazione rapida e pose di riferimento"
    ],
    useCasesTitle: "Casi d'uso",
    useCasesText: "Progettato per character artist, scultori di figure, sviluppatori di giochi e hobbisti della stampa 3D che necessitano di riferimenti anatomici accurati o mesh stampabili. Il generatore è utile per riferimenti di disegno dal vero, creazione di mesh di base, progettazione di protesi ed esplorazione artistica.",
    howItWorksTitle: "Come funziona",
    howItWorksText: "Tutta la geometria viene calcolata proceduralmente nel browser utilizzando Three.js. Nessuna risorsa viene scaricata: la mesh viene generata al volo da funzioni matematiche di superficie. Il rendering della pelle utilizza un materiale basato sulla fisica con scattering sub-superficiale per simulare la profondità e la traslucenza realistiche del tessuto. I file esportati sono mesh pulite e molteplici pronte per l'affettatura o la scultura.",
    back: "← Apri Generatore",
    generator: "Generatore"
  },
  pt: {
    about: "Sobre",
    title: "Boobs Works — Gerador de Busto 3D",
    intro: "Boobs Works é um gerador de busto 3D paramétrico gratuito baseado em navegador para artistas, escultores e entusiastas de impressão 3D. Ajuste a anatomia com controles em tempo real e exporte malhas prontas para produção no formato STL ou OBJ — nenhuma instalação de software necessária.",
    featuresTitle: "Recursos",
    features: [
      "10 controles paramétricos: volume, flacidez, geometria do mamilo, tamanho da aréola, tom de pele, rugosidade, dispersão subsuperficial e detalhes das veias",
      "Renderização WebGL em tempo real com shaders de pele GLSL personalizados",
      "Exportação para STL (para impressão 3D) ou OBJ (para uso no Blender, ZBrush, Maya, etc.)",
      "Predefinições integradas: Pequena, Natural, Cheia, Atlética, Escura",
      "Gerador aleatório para inspiração rápida e poses de referência"
    ],
    useCasesTitle: "Casos de Uso",
    useCasesText: "Projetado para artistas de personagens, escultores de figuras, desenvolvedores de jogos e amadores de impressão 3D que precisam de referências anatômicas precisas ou malhas imprimíveis. O gerador é útil para referências de desenho de observação, criação de malha base, design de próteses e exploração artística.",
    howItWorksTitle: "Como Funciona",
    howItWorksText: "Toda a geometria é calculada de forma procedural no navegador usando Three.js. Nenhum ativo é baixado — a malha é gerada em tempo real a partir de funções de superfície matemáticas. A renderização da pele usa um material baseado em física com dispersão subsuperficial para simular profundidade e translucidez de tecido realistas. Os arquivos exportados são malhas limpas e múltiplas prontas para fatiamento ou escultura.",
    back: "← Abrir Gerador",
    generator: "Gerador"
  },
  zh: {
    about: "关于",
    title: "Boobs Works — 3D胸围生成器",
    intro: "Boobs Works是一个面向艺术家、雕塑家和3D打印爱好者的免费、基于浏览器的参数化3D胸围生成器。使用实时控件调整解剖结构，并导出STL或OBJ格式的生产就绪网格——无需安装软件。",
    featuresTitle: "特点",
    features: [
      "10个参数控制：体积、下垂、乳头几何形状、乳晕大小、肤色、粗糙度、次表面散射和静脉细节",
      "带有自定义GLSL皮肤着色器的实时WebGL渲染",
      "导出到STL（用于3D打印）或OBJ（用于Blender、ZBrush、Maya等）",
      "内置预设：娇小、自然、丰满、运动、深色",
      "用于快速灵感和参考姿势的随机生成器"
    ],
    useCasesTitle: "使用案例",
    useCasesText: "专为需要准确解剖参考或可打印网格的角色艺术家、人物雕塑家、游戏开发人员和3D打印爱好者而设计。该生成器可用于写生参考、基础网格创建、修复学设计和艺术探索。",
    howItWorksTitle: "工作原理",
    howItWorksText: "所有几何图形都是在浏览器中使用Three.js按程序计算的。没有下载任何资产——网格是由数学表面函数动态生成的。皮肤渲染使用具有次表面散射的基于物理的材质，以模拟逼真的组织深度和半透明度。导出的文件是干净的流形网格，可以进行切片或雕刻。",
    back: "← 打开生成器",
    generator: "生成器"
  },
  ja: {
    about: "概要",
    title: "Boobs Works — 3Dバストジェネレーター",
    intro: "Boobs Worksは、アーティスト、彫刻家、3Dプリント愛好家向けの無料のブラウザベースのパラメトリック3Dバストジェネレーターです。リアルタイムコントロールで解剖学的構造を調整し、ソフトウェアをインストールすることなく、STLまたはOBJ形式でプロダクションレディなメッシュをエクスポートできます。",
    featuresTitle: "特徴",
    features: [
      "10個のパラメトリックコントロール：ボリューム、たるみ、乳首の形状、乳輪のサイズ、肌のトーン、粗さ、サブサーフェススキャタリング、静脈のディテール",
      "カスタムGLSLスキンシェーダーを使用したリアルタイムWebGLレンダリング",
      "STL（3Dプリント用）またはOBJ（Blender、ZBrush、Mayaなどでの使用）へのエクスポート",
      "組み込みプリセット：プチ、ナチュラル、フル、アスレチック、ダーク",
      "迅速なインスピレーションとリファレンスポーズのためのランダムジェネレーター"
    ],
    useCasesTitle: "ユースケース",
    useCasesText: "正確な解剖学的リファレンスまたは印刷可能なメッシュを必要とするキャラクターアーティスト、フィギュア彫刻家、ゲーム開発者、および3Dプリントの愛好家向けに設計されています。ジェネレーターは、デッサンのリファレンス、ベースメッシュの作成、補綴物の設計、芸術的な探求に役立ちます。",
    howItWorksTitle: "仕組み",
    howItWorksText: "すべてのジオメトリは、Three.jsを使用してブラウザ内で手続き的に計算されます。アセットはダウンロードされません。メッシュは、数学的な表面関数からオンザフライで生成されます。スキンレンダリングでは、サブサーフェススキャタリングを備えた物理ベースのマテリアルを使用して、リアルな組織の深さと半透明性をシミュレートします。エクスポートされたファイルは、スライスやスカルプトの準備ができているクリーンな多様体メッシュです。",
    back: "← ジェネレーターを開く",
    generator: "ジェネレーター"
  },
  ko: {
    about: "소개",
    title: "Boobs Works — 3D 흉상 생성기",
    intro: "Boobs Works는 아티스트, 조각가 및 3D 프린팅 애호가를 위한 무료 브라우저 기반 파라메트릭 3D 흉상 생성기입니다. 실시간 컨트롤로 해부학적 구조를 조정하고 소프트웨어 설치 없이 STL 또는 OBJ 형식의 프로덕션 지원 메시를 내보낼 수 있습니다.",
    featuresTitle: "특징",
    features: [
      "10가지 파라메트릭 제어: 볼륨, 처짐, 유두 기하학, 유륜 크기, 피부 톤, 거칠기, 표면 하 산란 및 정맥 디테일",
      "맞춤형 GLSL 피부 셰이더를 사용한 실시간 WebGL 렌더링",
      "STL(3D 프린팅용) 또는 OBJ(Blender, ZBrush, Maya 등에서 사용하기 위한)로 내보내기",
      "기본 제공 사전 설정: 아담한, 자연스러운, 풍만한, 운동선수 같은, 어두운",
      "빠른 영감과 참조 포즈를 위한 무작위 생성기"
    ],
    useCasesTitle: "사용 사례",
    useCasesText: "정확한 해부학적 참조나 인쇄 가능한 메시가 필요한 캐릭터 아티스트, 인물 조각가, 게임 개발자 및 3D 프린팅 애호가를 위해 설계되었습니다. 생성기는 누드 크로키 참조, 기본 메시 생성, 보철 디자인 및 예술적 탐구에 유용합니다.",
    howItWorksTitle: "작동 방식",
    howItWorksText: "모든 형상은 Three.js를 사용하여 브라우저에서 절차적으로 계산됩니다. 에셋이 다운로드되지 않습니다. 메시는 수학적 표면 함수에서 즉석에서 생성됩니다. 피부 렌더링은 표면 하 산란이 있는 물리적 기반 재료를 사용하여 사실적인 조직 깊이와 반투명도를 시뮬레이션합니다. 내보낸 파일은 슬라이싱이나 스컬프팅을 할 준비가 된 깨끗한 매니폴드 메시입니다.",
    back: "← 생성기 열기",
    generator: "생성기"
  },
  ar: {
    about: "حول",
    title: "Boobs Works — مولد تمثال نصفي 3D",
    intro: "Boobs Works هو مولد تمثال نصفي 3D بارامتري مجاني قائم على المتصفح للفنانين والنحاتين وعشاق الطباعة ثلاثية الأبعاد. اضبط التشريح باستخدام عناصر تحكم في الوقت الفعلي وقم بتصدير شبكات جاهزة للإنتاج بتنسيق STL أو OBJ - لا يلزم تثبيت أي برنامج.",
    featuresTitle: "الميزات",
    features: [
      "10 عناصر تحكم بارامترية: الحجم، الترهل، هندسة الحلمة، حجم الهالة، لون البشرة، الخشونة، التشتت تحت السطحي، وتفاصيل الأوردة",
      "عرض WebGL في الوقت الفعلي مع تظليل بشرة GLSL مخصص",
      "تصدير إلى STL (للطباعة ثلاثية الأبعاد) أو OBJ (للاستخدام في Blender و ZBrush و Maya وما إلى ذلك)",
      "إعدادات مسبقة مدمجة: صغير، طبيعي، ممتلئ، رياضي، داكن",
      "مولد عشوائي للإلهام السريع والوضعيات المرجعية"
    ],
    useCasesTitle: "حالات الاستخدام",
    useCasesText: "مصمم لفناني الشخصيات ونحاتي الأشكال ومطوري الألعاب وهواة الطباعة ثلاثية الأبعاد الذين يحتاجون إلى مراجع تشريحية دقيقة أو شبكات قابلة للطباعة. المولد مفيد لمراجع الرسم من الطبيعة، وإنشاء الشبكة الأساسية، وتصميم الأطراف الصناعية، والاستكشاف الفني.",
    howItWorksTitle: "كيف يعمل",
    howItWorksText: "يتم حساب جميع الأشكال الهندسية إجرائياً في المتصفح باستخدام Three.js. لا يتم تنزيل أي أصول - يتم إنشاء الشبكة على الفور من وظائف السطح الرياضية. يستخدم عرض الجلد مادة مادية مع تشتت تحت السطح لمحاكاة عمق الأنسجة الواقعي والشفافية. الملفات المصدرة عبارة عن شبكات نظيفة ومتعددة جاهزة للتقطيع أو النحت.",
    back: "← فتح المولد",
    generator: "المولد"
  },
  tr: {
    about: "Hakkında",
    title: "Boobs Works — 3D Büst Oluşturucu",
    intro: "Boobs Works, sanatçılar, heykeltıraşlar ve 3D baskı meraklıları için tarayıcı tabanlı, ücretsiz, parametrik bir 3D büst oluşturucudur. Gerçek zamanlı kontrollerle anatomiyi ayarlayın ve STL veya OBJ formatında üretime hazır ağları dışa aktarın - yazılım kurulumuna gerek yoktur.",
    featuresTitle: "Özellikler",
    features: [
      "10 parametrik kontrol: hacim, sarkma, meme ucu geometrisi, areola boyutu, cilt tonu, pürüzlülük, yüzey altı saçılma ve damar detayı",
      "Özel GLSL cilt gölgelendiricileriyle gerçek zamanlı WebGL oluşturma",
      "STL'ye (3D baskı için) veya OBJ'ye (Blender, ZBrush, Maya vb.'de kullanmak için) dışa aktarma",
      "Yerleşik ön ayarlar: Minyon, Doğal, Dolgun, Atletik, Koyu",
      "Hızlı ilham ve referans pozları için rastgele oluşturucu"
    ],
    useCasesTitle: "Kullanım Durumları",
    useCasesText: "Doğru anatomik referanslara veya yazdırılabilir ağlara ihtiyaç duyan karakter sanatçıları, figür heykeltıraşları, oyun geliştiricileri ve 3D baskı hobileri için tasarlanmıştır. Oluşturucu, canlı çizim referansı, temel ağ oluşturma, protez tasarımı ve sanatsal keşif için kullanışlıdır.",
    howItWorksTitle: "Nasıl Çalışır",
    howItWorksText: "Tüm geometri Three.js kullanılarak tarayıcıda prosedürel olarak hesaplanır. Herhangi bir varlık indirilmez — ağ, matematiksel yüzey fonksiyonlarından anında oluşturulur. Cilt oluşturma, gerçekçi doku derinliğini ve yarı saydamlığını simüle etmek için yüzey altı saçılımlı fiziksel tabanlı bir malzeme kullanır. Dışa aktarılan dosyalar, dilimleme veya şekillendirme için hazır, temiz, çok katmanlı ağlardır.",
    back: "← Oluşturucuyu Aç",
    generator: "Oluşturucu"
  }
};
